import { useState } from "react";

const DEFAULT_WIDTH = 35;
const DEFAULT_HEIGHT = 20;
const DEFAULT_THUMB = 15;

export const CustomSwitch = ({
  switchWidth,
  switchHeight,
  thumbSize,
  checked,
  defaultChecked,
  disabled,
  onChange,
  name,
  id,
  className = "",
  style = {},
  ...rest
}) => {
  const width = Number(switchWidth) || DEFAULT_WIDTH;
  const height = Number(switchHeight) || DEFAULT_HEIGHT;
  const thumb = Number(thumbSize) || DEFAULT_THUMB;

  const padding = 2;
  const trackRadius = height / 2;
  const translateX = width - (thumb + padding * 2);

  const isControlled = checked !== undefined;
  const [internalChecked, setInternalChecked] = useState(
    Boolean(defaultChecked),
  );
  const isOn = isControlled ? checked : internalChecked;

  return (
    <label
      className={`inline-flex items-center cursor-pointer ${
        disabled ? "opacity-50 cursor-not-allowed" : ""
      } ${className}`}
      style={{ display: "inline-flex", ...style }}
    >
      <input
        type="checkbox"
        id={id}
        name={name}
        checked={isControlled ? checked : undefined}
        defaultChecked={!isControlled ? defaultChecked : undefined}
        disabled={disabled}
        onChange={(e) => {
          if (!isControlled) {
            setInternalChecked(e.target.checked);
          }
          if (onChange) onChange(e, e.target.checked);
        }}
        style={{ display: "none" }}
        {...rest}
      />
      <span
        aria-hidden="true"
        style={{
          position: "relative",
          width,
          height,
          borderRadius: trackRadius,
          backgroundColor: isOn ? "#00a7a6" : "#c2c2c2",
          transition: "background-color 0.3s ease",
          display: "inline-flex",
          alignItems: "center",
          padding,
        }}
      >
        <span
          className="custom-switch-thumb"
          style={{
            position: "absolute",
            left: padding,
            width: thumb,
            height: thumb,
            borderRadius: "9999px",
            backgroundColor: "#ffffff",
            boxSizing: "border-box",
            boxShadow: "0 1px 3px rgba(0,0,0,0.4)",
            transform: isOn ? `translateX(${translateX}px)` : "translateX(0)",
            transition: "transform 0.3s ease",
          }}
        />
      </span>
    </label>
  );
};
